import BasketSubscriber from "../components/BasketSubscriberReport/BasketSubscriber";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import config from "../config";

const BasketSubscriberReport = () => {

    const email1 = useSelector((state) => state.user.email);
    const navigate = useNavigate();
    useEffect(() => {
        if (email1 === null || email1 === "") {
            navigate("/")
        }
    })




    return (
        <div className=" my-12 md:px-1 max-w-screen-2xl mx-auto py-5">
            <BasketSubscriber />
        </div>
    )
}

export default BasketSubscriberReport

